import axios from 'axios'
import {getToken} from "@/utils/auth";
const request = {
    GET: function(path, param, config){
        let token =  "Bearer " + (config || {}).Authorization || getToken();
        let baseUrl = (config || {}).BASE_URL || process.env.VUE_APP_API_ROOT;
        return new Promise((resolve, reject) => {
            axios.get(baseUrl + path, {
                headers:{
                    Authorization: token
                },
                params: param,
            }).then((res)=>{
                resolve(res.data);
            }).catch(err => {
                reject(err);
            })
        })
    },
    POST: function(path, param, config){
        let token =  "Bearer " + (config || {}).Authorization || getToken();
        let baseUrl = (config || {}).BASE_URL || process.env.VUE_APP_API_ROOT;
        return new Promise((resolve, reject) => {
            axios.post(baseUrl + path, param,{
                headers:{
                    Authorization: token
                }
            }).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err);
            })
        })
    }
}
export default {
    /*获取上传策略*/
    uploadPolicy(param,config) {
        "use strict";
        return request.GET('/physical-file/physical/file/upload/policy', param, config);
    },
    /*上传文件保存*/
    uploadSave(param, config) {
        "use strict";
        return request.POST('/physical-file/physical/file/upload/save', param, config);
    },
    /*获取下载策略*/
    downloadPolicy(param, config) {
        "use strict";
        return request.POST('/physical-file/physical/file/download/policy', param, config);
    },
    /*根据文件信息， 获取下载地址*/
    getDownloadUrl(param, config) {
        "use strict";
        return request.POST('/physical-file/physical/file/download/url', param, config);
    },
    /*上传文件取消*/
    uploadCancel(param, config) {
        "use strict";
        return request.POST('/physical-file/physical/file/upload/cancel', param, config);
    },
    /*RVT重新转换*/
    retryConvertRvt(params, config) {
        "use strict";
        return request.POST('/doc/api/file/retryConvertRvt', params, config);
    }
}
